export enum FormType {
	create = 'create',
	edit = 'edit',
	view = 'view',
	specialEdit = 'specialEdit',
}
